/**
 * The Crewlark lark.
 *
 * The one piece of the brand that is drawn rather than written, kept as path
 * data rather than a bundled file so it scales to any size, takes its colour
 * from the place it is used, and costs nothing to load. The geometry is
 * `symbols/crewlark-*.svg` from the brand kit, outlined — there is no font
 * dependency and nothing to fetch.
 *
 * It replaced a letter in a rounded square, which was a placeholder from
 * before there was a logo.
 */

const RATIO = 385 / 265;

export function Lark({ width = 26, className }: { width?: number; className?: string }) {
  return (
    <svg
      width={width}
      height={width / RATIO}
      viewBox="0 0 385 265"
      className={className}
      role="img"
      aria-label="Crewlark"
    >
      <path fill="currentColor" fillRule="evenodd" d="M24 24C102 46 194 43 229 82C239 94 244 108 242 118C203 101 160 112 141 138C120 166 128 202 174 226C127 239 75 248 30 239C67 205 91 161 116 117C67 106 28 70 24 24ZM238 67C269 37 291 21 318 31C336 35 343 49 361 58C334 69 321 92 308 116C286 162 256 203 214 198C189 197 172 193 174 178C172 156 195 150 217 143C239 135 255 128 253 106C252 91 246 78 238 67ZM314 58C314 62.971 309.971 67 305 67C300.029 67 296 62.971 296 58C296 53.029 300.029 49 305 49C309.971 49 314 53.029 314 58Z" />
    </svg>
  );
}
